"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Search/index.js";
var timeout;
function Search(_ref) {
  var fields = _ref.fields,
    onSubmit = _ref.onSubmit;
  var _React$useState = _react["default"].useState({}),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    where = _React$useState2[0],
    setWhere = _React$useState2[1];
  function _onChange(value) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      onSubmit(where);
    }, 300);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-search position-absolute",
    style: {
      zIndex: 4,
      width: "50px",
      height: "50px",
      lineHeight: "40px",
      textAlign: "center"
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("input", {
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    type: "search",
    className: "form-control rounded-pill ps-5",
    placeholder: "Search",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-link border-0 p-0 ms-1 d-flex align-items-center",
    type: "button",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-filter fs-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 17
    }
  }), "Filter"));
}
var _default = exports["default"] = Search;